module.exports = __webpack_public_path__ + "static/media/101010-house-of-yes-unicorn.3304001a.mp4";